const usePermissionConfig = () => {
  return {
    /*
    * 新增
    * 控制：新增
    * 跳转路由名称：
    * */
    CREATE: 'OPS-XTPZ-WLGL-XZ',
    /*
    * 编辑
    * 控制：编辑
    * 跳转路由名称：
    * */
    UPDATE: 'OPS-XTPZ-WLGL-BJ',
    /*
    * 删除
    * 控制：删除
    * 跳转路由名称：
    * */
    DELETE: 'OPS-XTPZ-WLGL-SC',
  };
};

export default usePermissionConfig;
